import { useContext } from 'react'
import { MixpanelContext } from './mixpanel-context'

export const useMixpanel = (category: string) => {
  const { trackEvent } = useContext(MixpanelContext)

  return { trackEvent: trackEvent(category) }
}
